import { isNullOrWhitespace } from "@common/stringOperations";
import { ApprovalOption, GroupCompanyResponsible } from "../AnnualWheel.types";
import { ActivityFormProps } from "./ActivityForm.types";

export type ActivityGroupCompaniesSectionProps = Pick<ActivityFormProps, "model" | "onModelChange" | "showError" | "readOnly">;

export function useActivityGroupCompaniesSection(props: ActivityGroupCompaniesSectionProps) {
    const model = props.model;
    const hasResponsible = !isNullOrWhitespace(model.responsible);

    function onGroupCompaniesChange(groupCompanyIds: Array<string>) {
        const groupCompanies: Array<GroupCompanyResponsible> = groupCompanyIds.map((groupCompanyId) => ({
            groupCompanyId,
            userId: model.groupCompanies.find((groupCompany) => groupCompany.groupCompanyId === groupCompanyId)?.userId ?? null,
        }));
        // A newly added company has no responsible of its own yet, so approval needs the main responsible.
        const addsCompanyWithoutResponsible = groupCompanyIds.some((id) => !model.groupCompanies.some((groupCompany) => groupCompany.groupCompanyId === id));
        const losesApprover = !hasResponsible && (groupCompanyIds.length === 0 || addsCompanyWithoutResponsible);

        props.onModelChange({ groupCompanies, approval: losesApprover ? ApprovalOption.ApprovalNotRequired : model.approval });
    }

    function onGroupCompanyResponsibleChange(userId: string | null, groupCompanyId: string) {
        const groupCompanies = model.groupCompanies.map((groupCompany) =>
            groupCompany.groupCompanyId === groupCompanyId ? { ...groupCompany, userId } : groupCompany
        );
        const losesApprover = isNullOrWhitespace(userId ?? undefined) && !hasResponsible;

        props.onModelChange({ groupCompanies, approval: losesApprover ? ApprovalOption.ApprovalNotRequired : model.approval });
    }

    return {
        onGroupCompaniesChange,
        onGroupCompanyResponsibleChange,
        showResponsibleError: props.showError && model.isResponsibleMissing(),
    };
}
